<template>
  <div class="project-staff-info">
    <div class="app-title mb">编辑集团员工</div>
    <el-form class="max-width" ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入员工姓名"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model="form.sex">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="账号">
        <el-input v-model="account" disabled></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入员工手机号"></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="department">
        <el-input v-model="form.department" placeholder="请输入员工部门"></el-input>
      </el-form-item>
      <el-form-item label="职务" prop="job">
        <el-input v-model="form.job" placeholder="请输入员工职务"></el-input>
      </el-form-item>
      <el-form-item label="照片" prop="avatarId">
        <p class="app-danger-tips">上传清晰的正脸照片，照片质量和数量影响识别效果</p>
        <el-upload
          class="el-upload-wrap avatar"
          action="/admin/face/user/upload"
          name="face_img"
          accept="image/*"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          :before-upload="beforeUpload"
          :on-progress="uploadProgress"
          v-loading="uploadLoading"
        >
          <el-image :src="avatarUrl" v-if="avatarUrl"></el-image>
          <i class="el-icon-plus" v-else></i>
        </el-upload>
        <p class="app-tips">只能上传jpg/png文件，且不超过5M</p>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import regex from '@/assets/utils/regex.js';
  import ProjectService from '@/io/project.js';

  export default {
    name: 'PojectStaffInfo',
    props: {
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        checkPhone: this.debounce((value, callback) => {
          if (!regex.phone.rule.test(value)) {
            callback(new Error(regex.phone.text));
          } else {
            callback();                  
          }
        }, 1000),
        account: '',
        avatarUrl: '',
        uploadLoading: false,
        form: {
          name: '',
          sex: 1,
          phone: '',
          department: '',
          job: '',
          avatarId: ''
        },
        rules: {
          name: [
            {
              required: true, message: '请输入员工姓名'
            }
          ],
          sex: [
            {
              required: true, message: '请输入员工性别'
            }
          ],
          phone: [
            {
              required: true, message: '请输入员工手机号'
            },
            {
              validator(rule, value, callback) {
                self.checkPhone(value, callback);
              }
            }
          ],
          department: [
            {
              required: true, message: '请输入员工部门'
            }
          ],
          job: [
            {
              required: true, message: '请输入员工职务'
            }
          ],
          avatarId: [
            {
              required: true, message: '请上传照片'
            }
          ]
        },
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initDatas();
          }
        },
        immediate: true
      }
    },
    methods: {
      initDatas() {
        ProjectService.staffInfo(this.id).then(res => {
          this.form.name = res.data.attr_data.user_attr_name;
          this.form.sex = res.data.attr_data.user_attr_gender;
          this.account = res.data.attr_data.user_attr_account;
          this.form.phone = res.data.attr_data.user_attr_phone;
          this.form.department = res.data.attr_data.user_attr_department;
          this.form.job = res.data.attr_data.user_attr_title;
          this.avatarUrl = res.data.face_data.attachment_access_url;
          this.form.avatarId = res.data.face_data.attachment_id;
        }).catch(() => {});
      },
      uploadSuccess(response, file) {
        this.avatarUrl = URL.createObjectURL(file.raw);
        this.form.avatarId = response.data.attachment_id;
        this.uploadLoading = false;
      },
      uploadError() {
        this.uploadLoading = false;
        this.$message.error('上传失败');
      },
      beforeUpload(file) {
        let isExceedSize = file.size > 5242880;
        if (isExceedSize) {
          this.$message.error('图片太大');
        }
        return !isExceedSize;
      },
      uploadProgress() {
        this.uploadLoading = true;
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            ProjectService.editStaff(
              this.id,
              this.form.name,
              this.form.sex,
              this.form.phone,
              this.form.department,
              this.form.job,
              this.form.avatarId
            ).then(() => {
              this.$message.success('编辑成功');
              this.$emit('submit');
              this.$emit('cancel');
            }).catch(() => {});
          }
        });
      },
      cancel() {
        this.$emit('cancel');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>